import { Link } from 'react-router-dom';
import { ErrorBox, Loading, api, useAction, useLoad, when } from '../ui.tsx';

export function Messages() {
  const { data, error, loading, setData } = useLoad(() => api.messages());
  const action = useAction();
  if (loading && !data) return <Loading />;
  if (!data) return <ErrorBox error={error} />;
  const toggle = (id: string, status: 'new' | 'done') =>
    action.run(async () => {
      await api.setMessageStatus(id, status);
      setData(data.map((m) => (m.id === id ? { ...m, status } : m)));
    });
  return (
    <>
      <h1>Messages</h1>
      <ErrorBox error={action.error} />
      {!data.length && <p className="muted">No messages yet. They arrive from the Contact page.</p>}
      <ul className="msgs">
        {data.map((m) => (
          <li key={m.id} className={m.status === 'new' ? 'is-new' : ''}>
            <div className="msgs__head">
              <strong>{m.name}</strong> <a href={`mailto:${m.email}`}>{m.email}</a>
              {m.orderNumber && <> · <Link to={`/orders/${m.orderNumber}`}>Order #{m.orderNumber}</Link></>}
              <small className="muted"> · {when(m.createdAt)}</small>
            </div>
            <p>{m.message}</p>
            <button className="mini" disabled={action.busy} onClick={() => void toggle(m.id, m.status === 'new' ? 'done' : 'new')}>
              {m.status === 'new' ? 'Mark done' : 'Mark new'}
            </button>
          </li>
        ))}
      </ul>
    </>
  );
}
